// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_6f25b66c20--tabs--3H6nq"};